import {List} from 'immutable';

import RESTClient from 'web-app/api/clients/rest-client-famly-app';
import Group from 'web-app/react/entities/groups/model';
import BehaviorsCollection from 'web-app/behaviors/behaviors-collection';

import Institution from './model';
import OpeningHours from '../common/opening-hours';

export const fetch = institutionId => {
    return RESTClient.getAuthenticatedObservable('daycare/institution/show', {
        institutionId,
    }).map(response => ({
        institution: Institution.fromAPI(response.institution),
    }));
};

export const update = institution => {
    return RESTClient.postAuthenticatedObservable('daycare/institution/update', institution).map(response => ({
        institution: Institution.fromAPI(response.institution),
    }));
};

/**
 * @deprecated use the useStatSettings().openingHours  instead
 */
export const fetchOpeningHours = institutionId => {
    return RESTClient.getAuthenticatedObservable(`v2/institutions/${institutionId}/openinghours`, {
        behaviors: true,
    }).map(response => ({
        behaviors: new BehaviorsCollection(response.behaviors),
        openingHours: List(response.openingHours).map(OpeningHours.fromAPI),
    }));
};

export const updateOpeningHours = (institutionId, openingHours) => {
    return RESTClient.postAuthenticatedObservable(`v2/institutions/${institutionId}/openinghours`, {
        days: openingHours,
    }).map(oh => List(oh.map(OpeningHours.fromAPI)));
};

export const fetchGroups = institutionId => {
    return RESTClient.getAuthenticatedObservable('v2/groups', {institutionId}).map(groupObj =>
        List(groupObj.map(Group.fromAPI)),
    );
};
